export default __webpack_public_path__ + "static/media/left-rotate.c3762c0d.svg";